import customAxios from "../../customAxios";
import { DELETE_CLIENT } from "../../routes";

const deleteClient = async (userId: string) => {
  try {
    return (await customAxios.delete(DELETE_CLIENT + `/${userId}`)).data;
  } catch (error: any) {
    console.log({ DELETE_CLIENT: error });
    return false;
  }
};

export default deleteClient;
